export type AuthAbilities = Record<
  string,
  {
    full_access: boolean;
    [key: string]: boolean;
  }
>;

export interface AuthModeratorAbilities {
  auth: AuthAbilities;
  brisk: AuthAbilities;
  umpire: AuthAbilities;
  wicket: AuthAbilities;
}
